"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuerySwitch = exports.QueryRoute = exports.DialogRoute = exports.matchesQuery = void 0;
var tslib_1 = require("tslib");
var matches_query_1 = require("./matches-query");
Object.defineProperty(exports, "matchesQuery", {
  enumerable: true,
  get: function () {
    return matches_query_1.matchesQuery;
  }
});
var dialog_route_1 = require("./dialog-route");
Object.defineProperty(exports, "DialogRoute", {
  enumerable: true,
  get: function () {
    return dialog_route_1.DialogRoute;
  }
});
var query_route_1 = require("./query-route");
Object.defineProperty(exports, "QueryRoute", {
  enumerable: true,
  get: function () {
    return query_route_1.QueryRoute;
  }
});
var query_switch_1 = require("./query-switch");
Object.defineProperty(exports, "QuerySwitch", {
  enumerable: true,
  get: function () {
    return query_switch_1.QuerySwitch;
  }
});
tslib_1.__exportStar(require("./merge-query-string"), exports);
tslib_1.__exportStar(require("./update-search"), exports);
tslib_1.__exportStar(require("./close-dialog"), exports);